import { render, staticRenderFns } from "./RulerTicks.vue?vue&type=template&id=5cc44082"
import script from "./RulerTicks.vue?vue&type=script&lang=js"
export * from "./RulerTicks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports